import React, { useState } from "react";
import { Table } from "antd";
import "./CustomTable.css"; // Ensure this file is created with styles below

const CustomTable = ({
  columns,
  dataSource,
  onChange,
  rowKey = "_id",
  customPagination,
  style = {},
  ...props
}) => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
    total: 0,
  });

  console.log(customPagination, "customPagination");
  const handleTableChange = (pagination) => {
    console.log("Current Page:", pagination.current); // Capture current page number

    setPagination(pagination);
  };

  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      rowKey={rowKey}
      bordered
      className="styled-table"
      style={{
        backgroundColor: "#f4f8fc", // Slightly faded background
        borderRadius: "8px",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
        ...style,
      }}
      size="middle"
      {...props}
      scroll={{
        y: 410,
        x: "max-content",
      }}
      tableLayout="auto"
      pagination={{
        showSizeChanger: true,
        pageSizeOptions: ["5", "10", "20", "50"],
        position: ["bottomCenter"],
        ...customPagination,
      }}
      // onChange={handleTableChange}
      onChange={onChange}
    />
  );
};

export default CustomTable;
